/**
 * Regional deployment registry.
 *
 * This front-end is built ONCE and the same dist/ is uploaded to every regional
 * host. The region is resolved at runtime from window.location.hostname, so
 * nothing region-specific is ever baked into the bundle.
 *
 * Adding a region: add one line to REGIONS and drop its logo in
 * public/branding/<code>.png.
 *
 * Keep this module free of Vue/store imports: themeConfig.js imports it, and
 * the app store imports themeConfig.
 */

const STM = 'systemstailormade.com';

function region(code, host) {
  return {
    code,
    name: `${code} Rota Planner`,
    host,
    apiUrl: `https://api.${host}/public/api`,
    storageUrl: `https://api.${host}/storage/app/public`,
    logo: `/branding/${code.toLowerCase()}.png`,
  };
}

export const REGIONS = [
  region('SLCIS', `planning.${STM}`),
  region('SMCIS', `smcis-rostering.${STM}`),
  region('NDCIS', `ndcis-rostering.${STM}`),
  region('DSCIS', `dscis-rostering.${STM}`),
  region('NLCIS', `nlcis-rostering.${STM}`),
  region('NMCIS', `nmcis-rostering.${STM}`),
  region('SCCIS', `sccis-rostering.${STM}`),
];

export const DEFAULT_LOGO = '/branding/default.png';

// The user manual is hosted once, on the SLCIS server, and shared by every
// region. This is deliberate, not a missed toggle.
export const SHARED_MANUAL_URL = `https://api.planning.${STM}/storage/app/public/cis_user_manual.mp4`;

export function resolveRegion(hostname) {
  const host = String(hostname || '')
    .replace(/^www\./, '')
    .toLowerCase();

  // 1. Local development overrides. Ignored in production builds so a stray
  //    .env.local can never ship inside a deployed bundle.
  if (
    process.env.NODE_ENV !== 'production'
    && (process.env.VUE_APP_API_URL || process.env.VUE_APP_REGION)
  ) {
    const base = REGIONS.find(
      (r) => r.code === String(process.env.VUE_APP_REGION || '').toUpperCase(),
    );
    return {
      ...(base || { code: 'DEV', name: 'Rota Planner (dev)', logo: DEFAULT_LOGO }),
      apiUrl: process.env.VUE_APP_API_URL || (base && base.apiUrl),
      storageUrl: process.env.VUE_APP_STORAGE_URL || (base && base.storageUrl),
    };
  }

  // 2. Known regional host.
  const hit = REGIONS.find((r) => r.host === host);
  if (hit) return hit;

  // 3. Unknown host: fall back to the api.<host> convention so a newly added
  //    deployment is never a white screen.
  // eslint-disable-next-line no-console
  console.warn(`[regions] unknown host "${host}", falling back to api.${host}`);
  return {
    code: 'UNKNOWN',
    name: 'Rota Planner',
    host,
    apiUrl: `https://api.${host}/public/api`,
    storageUrl: `https://api.${host}/storage/app/public`,
    logo: DEFAULT_LOGO,
  };
}

export default resolveRegion(
  typeof window !== 'undefined' ? window.location.hostname : '',
);
